import {api} from "../main";

export default {
    /**
     * Listar escuelas con paginación y filtros
     * Parámetros opcionales: estatus, formato, search, ciudad, per_page
     */
    getEscuelas(params = {}) {
        return api({
            url: `/api/escuelas`,
            method: 'GET',
            params: params,
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
    },

    /**
     * Obtener una escuela específica por ID
     */
    getEscuela(id) {
        return api({
            url: `/api/escuelas/${id}`,
            method: 'GET',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
    },

    /**
     * Crear nueva escuela
     */
    createEscuela(data) {
        return api({
            url: `/api/escuelas`,
            method: 'POST',
            data: data,
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
    },

    /**
     * Actualizar escuela existente
     */
    updateEscuela(id, data) {
        return api({
            url: `/api/escuelas/${id}`,
            method: 'PUT',
            data: data,
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
    },

    /**
     * Eliminar escuela (soft delete)
     */
    deleteEscuela(id) {
        return api({
            url: `/api/escuelas/${id}`,
            method: 'DELETE',
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
    },

    /**
     * Obtener escuelas para selects (sin paginación)
     */
    getEscuelasParaSelect(params = {estatus: 1, formato: 'select'}) {
        return api({
            url: `/api/escuelas`,
            method: 'GET',
            params: params,
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
    },

    /**
     * Obtener usuarios por dominio para selección de admin
     */
    getUsuariosPorDominio(domain) {
        return api({
            url: `/api/escuelas/usuarios-por-dominio`,
            method: 'GET',
            params: { domain },
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
    },

    /**
     * Verificar si un dominio ya está registrado
     */
    verificarDominio(domain, escuelaId = null) {
        return api({
            url: `/api/escuelas/verificar-dominio`,
            method: 'GET',
            params: { domain, escuela_id: escuelaId },
            headers: {
                'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization',
            }
        });
    }
};
